import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlgoliaBroker } from '@fnModels/algolia/broker';
import { Select } from '@ngxs/store';
import { BrokerSearchState } from '@state/algolia-search/broker-search';
import {
	BrokerageSearchDispatch,
	BrokerageSearchState,
} from '@state/algolia-search/brokerage-search';
import { Observable, combineLatest } from 'rxjs';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { BrokerSearchDispatch } from '@state/algolia-search/broker-search/broker-search.dispatch';
import {
	CreateBrokerageComponent,
	CreateOrUpdateBrokerageModel,
} from '../create/create.component';
import { Brokerage } from '@models/matter';
import { Employee } from '@models/company';
import { TestHooks } from './search.hooks';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';

export enum DropdownSelect {
	SELECTBROKERAGE = 'SelectBrokerage',
	SELECTBROKER = 'SelectBroker',
}

@UntilDestroy()
@Component({
	selector: 'app-brokerage-search',
	templateUrl: './search.component.html',
	standalone: false,
})
export class BrokerageSearchComponent implements OnInit {
	testHooks = TestHooks;
	public selected;
	public ICON = ICON;
	public showDropdown = false;
	public _brokers = [];
	public _brokerages = [];
	public loading = false;
	public brokerageModel: CreateOrUpdateBrokerageModel;
	public dropdownSelect = DropdownSelect;

	@Input() label = '';
	@Input() isClient;
	@Input() orientation: 'row' | 'col' = 'col';
	@Input() skeletonLoading = false;

	brokerageName = '';
	saleId;
	@ViewChild('brokerage', { static: true }) brokerage: ElementRef;

	@Output() onSelectedBrokerage = new EventEmitter<Brokerage>();
	@Output() onSelectedBroker = new EventEmitter<AlgoliaBroker>();
	@Output() onRemoveBroker = new EventEmitter();
	@Output() onFocus = new EventEmitter();

	@Select(BrokerageSearchState.getList) brokerages$: Observable<Brokerage[]>;
	@Select(BrokerageSearchState.getSearching) searchingBrokerages$: Observable<
		boolean[]
	>;

	@Select(BrokerSearchState.getList) brokers$: Observable<Employee[]>;
	@Select(BrokerSearchState.getSearching)
	searchingBrokers$: Observable<boolean>;

	@SelectSnapshot(SelectedMatter.isLeapMatter) isLeapMatter: boolean;

	constructor(
		private dialog: MatDialog,
		private brokerSearchDispatch: BrokerSearchDispatch,
		private brokerageSearchDispatch: BrokerageSearchDispatch,
	) {
		this.brokerSearchDispatch.resetBrokerSearch();
		this.brokerageSearchDispatch.resetSearch();
	}

	ngOnInit(): void {
		combineLatest([this.brokerages$, this.brokers$])
			.pipe(
				untilDestroyed(this),
				map(([brokerages, brokers]) => {
					this.loading = false;
					this._brokerages = brokerages;
					this._brokers = brokers;
				}),
			)
			.subscribe();
	}

	search = ($event) => {
		this.loading = true;
		//if (!this.isLeapMatter) {
		// For LEAP matters we don't search brokers while searching brokerages.
		this.brokerSearchDispatch.searchBrokers($event);
		//}
		this.brokerageSearchDispatch.Search($event);
	};

	_onFocus() {
		this.onFocus.emit();
	}

	createBrokerage() {
		this.brokerageModel = {
			name: this.selected,
			isClient: this.isClient,
			brokerage: null,
		};
		const dialogRef = this.dialog.open(CreateBrokerageComponent, {
			width: '800px',
			height: '700px',
			data: this.brokerageModel,
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.onSelectedBrokerage.emit(result);
			}
		});
	}

	onSelect = (ev: DropdownResult<AlgoliaBroker | Brokerage>) => {
		if (ev.groupType === DropdownSelect.SELECTBROKERAGE) {
			const result = ev.result as Brokerage;
			this.onSelectedBrokerage.emit(result);
		} else if (ev.groupType === DropdownSelect.SELECTBROKER) {
			const result = ev.result as AlgoliaBroker;
			this.onSelectedBroker.emit(result);
		}
	};
}
